import { Box, CSSObject } from '@mui/material'
import { forwardRef } from 'react'

import { FlexBoxProps } from './types'

export const FlexBox = forwardRef<HTMLDivElement, FlexBoxProps>(({ axis, ...muiBoxProps }, ref) => {
  const axisProps = (): CSSObject => {
    switch (axis) {
      case 'x': {
        return {
          flexDirection: 'row',
        }
      }
      case 'xy': {
        return {
          flexDirection: 'column',
          justifyContent: 'center',
        }
      }
      case 'y': {
        return {
          flexDirection: 'column',
        }
      }
    }
  }

  return (
    <Box
      ref={ref}
      {...muiBoxProps}
      sx={{
        alignItems: 'center',
        display: 'flex',
        ...axisProps(),
        ...muiBoxProps.sx,
      }}
    />
  )
})

FlexBox.displayName = 'FlexBox'
